class SiteSubNav extends CustomElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initProps();
        this.addEventListeners();
    }

    initProps() {
        this.productBlock = this.querySelector('navigation-product-card');
        this.products = this.querySelectorAll('li');
    }

    renderFirstProduct() {
        const firstProduct = this.products[0];
        this.updateProductDisplay(firstProduct);
    }

    addEventListeners() {
        this.products.forEach(element => {
            element.addEventListener('mouseover', () => {
                this.updateProductDisplay(element);
            });
        });
    }

    updateProductDisplay(element) {
        const product = JSON.parse(element.getAttribute('data-product'));
        const accentuate = JSON.parse(element.getAttribute('data-accentuate'));

        this.renderProductInformation(product, accentuate);
    }

    renderProductInformation(product, accentuate) {
        this.productBlock.updateState(product, accentuate);
    }
}

customElements.define('navigation-subnav', SiteSubNav);